import React from "react";
import ConfigSection from "../../ConfigSection";

const DepartmentSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Department'
      configType='Department'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default DepartmentSection;
